<template>
    <b-form-group
        :label="inputLabel"
        :label-for="inputId"
        :class="{
            'required-field': required,
        }"
    >
        <b-form-file
            ref="file-input"
            :id="inputId"
            :name="inputName"
            v-bind="$attrs"
            :disabled="loading || disabled"
            @input="fileCompressor"
            :placeholder="getPlaceholder()"
        ></b-form-file>
    </b-form-group>
</template>

<script>
import { mapGetters } from 'vuex'
import request from '@/utils/request'

export default {
    /*
  |--------------------------------------------------------------------------
  | Component > components
  |--------------------------------------------------------------------------
  */
    components: {}, // End of Component > components

    /*
  |--------------------------------------------------------------------------
  | Component > props
  |--------------------------------------------------------------------------
  */
    props: {
        inputId: {
            type: String,
        },
        inputName: {
            type: String,
        },
        inputLabel: {
            type: String,
        },
        fileType: {
            type: String,
        },
        disabled: {
            type: Boolean,
        },
        value: {
            type: String,
        },
        required: {
            type: Boolean,
            default: false,
        },
        field: {
            type: Object,
        },
        customValue: {
            type: Object,
        },
    }, // End of Component > props

    /*
  |--------------------------------------------------------------------------
  | Component > data
  |--------------------------------------------------------------------------
  */
    data() {
        return {}
    }, // End of Component > data

    /*
  |--------------------------------------------------------------------------
  | Component > computed
  |--------------------------------------------------------------------------
  */
    computed: {
        ...mapGetters(['loading','getField']),
    }, // End of Component > methods

    /*
  |--------------------------------------------------------------------------
  | Component > mounted
  |--------------------------------------------------------------------------
  */
    mounted() {
        // console.log('this field',this.field ? this.field.originalFileNameKey : '')
        // console.log('another field',this.customValue)
        this.getPlaceholder()
    }, // End of Component > computed

    /*
  |--------------------------------------------------------------------------
  | Component > methods
  |--------------------------------------------------------------------------
  */
    methods: {
        getPlaceholder()
        {
            if(this.customValue && this.customValue.originalFileName)
        {
            return this.customValue.originalFileName
        }
        if(this.field){
            if(this.field.placeholder)
            {
                return this.field.placeholder
            }
            else if( this.field.originalFileNameKey && this.getField(this.field.originalFileNameKey)){
                return this.getField(this.field.originalFileNameKey)
            }
        }
        return "Select scan copy (JPG, PNG, PDF or JPEG file)"
        },
        onHidden() {
            this.$refs['file-input'].reset()

            this.$store.commit('updateField', {
                key: this.field.originalFileNameKey,
                value: null,
            })
            this.$store.commit('updateField', {
                key: this.field.key,
                value: null,
            })
        },
        encrypt(input) {
            // console.log(input)
            var file = input

            if (file) {
                if (
                    file.type === 'image/jpeg' ||
                    file.type === 'image/jpg' ||
                    file.type === 'image/png' ||
                    file.type === 'application/pdf'
                ) {
                    console.log('File type available')
                    var reader = new FileReader()

                    reader.onload = () => {
                        console.log('File reader on Load')

                        // var key = process.env.VUE_APP_CRYPTO_SECERT_KEY
                        var wordArray = this.CryptoJS.lib.WordArray.create(
                            reader.result
                        ) // Convert: ArrayBuffer -> WordArray
                        var encrypted = this.$encrypt(wordArray,false)// Encryption: I: WordArray -> O: -> Base64 encoded string (OpenSSL-format)

                        var fileEnc = new Blob([encrypted]) // Create blob from string
                        var filename = file.name + '.enc'
                        const myFile = new File([fileEnc], filename, {
                            type: fileEnc.type,
                        })

                        this.onFileInput(myFile)
                    }

                    console.log('File before Buffer', file)

                    reader.readAsArrayBuffer(file)
                } else {
                    console.log('No file Type')
                    this.$store.commit('setError', 'File format not supported')
                    this.onHidden()
                    // this.$refs['file-input'].reset()
                }
            }

            // reader.readAsArrayBuffer(compressFile);
            // console.log(file)
        },

        fileCompressor(input) {
            var file = input
            if (file) {
                if (
                    file.type === 'image/jpeg' ||
                    file.type === 'image/jpg' ||
                    file.type === 'image/png' 
                ) { console.log(file.type)
                    var readerImage = new FileReader()
                    readerImage.readAsDataURL(file)

                    readerImage.onload = (event) => {
                        const imgElement = document.createElement('img')
                        imgElement.src = event.target.result
                        // document.querySelector("#input").src = event.target.result;
                        console.log('imgElement.src')
                        console.log('Input', input)
                        imgElement.onload = (e) => {
                            const canvas = document.createElement('canvas')
                            const MAX_WIDTH = 1000

                            const scaleSize = MAX_WIDTH / e.target.width
                            canvas.width = MAX_WIDTH
                            canvas.height = e.target.height * scaleSize

                            const ctx = canvas.getContext('2d')

                            ctx.drawImage(
                                e.target,
                                0,
                                0,
                                canvas.width,
                                canvas.height
                            )

                            const srcEncoded = ctx.canvas.toDataURL(
                                e.target,
                                'image/jpeg'
                            )

                            console.log('srcEncoded', srcEncoded)
                            // file = dataURLtoFile([srcEncoded] , file.name , file.type  )
                            var arr = srcEncoded.split(','),
                                mime = arr[0].match(/:(.*?);/)[1],
                                bstr = atob(arr[1]),
                                n = bstr.length,
                                u8arr = new Uint8Array(n)

                            while (n--) {
                                u8arr[n] = bstr.charCodeAt(n)
                            }

                            const fileConverted = new File([u8arr], file.name, {
                                type: mime,
                            })
                            console.log('FIle Converted', fileConverted)
                            // file = fileConverted

                            this.encrypt(fileConverted)
                        }
                    }
                }
                else if(file.type === 'application/pdf'){
                    this.onFileInput(file)
                } 
                else {
                    console.log(file.type)
                    console.log('No file Type')
                    this.$store.commit('setError', 'File format not supported')
                    this.onHidden()
                    // this.$refs['file-input'].reset()
                }

                // console.log("File reader on Load");
                //
                // var key = process.env.VUE_APP_CRYPTO_SECERT_KEY;
                // var wordArray = this.CryptoJS.lib.WordArray.create(
                //   readerImage.result
                // ); // Convert: ArrayBuffer -> WordArray
                // var encrypted = this.CryptoJS.AES.encrypt(
                //   wordArray,
                //   key
                // ).toString(); // Encryption: I: WordArray -> O: -> Base64 encoded string (OpenSSL-format)
                //
                // var fileEnc = new Blob([encrypted]); // Create blob from string
                // var filename = fileConverted.name + ".enc";
                // const myFile = new File([fileEnc], filename, {
                //   type: fileEnc.type
                // });
                //
                // this.onFileInput(myFile);
            }
         
        },
        /**
         * Handle when the user selects a file
         *
         * @return {void}
         */
        async onFileInput(file) {
        
            if (file) {
                // this.encrypt(file)
                this.$store.commit('setLoading', true)
                try {
                    const formData = new FormData()

                    formData.append('type', this.fileType)
                    formData.append('file', file)

                    const headers = {
                        'Content-Type': 'multipart/form-data',
                    }
                    const { data } = await request.post(
                        'files/encrypt',
                        formData,
                        {
                            headers,
                        }
                    )

                    this.$emit('input', data.data.fileName)
                    this.$emit('update:originalFileName', file.name)
                    this.$emit('data', {
                        fileName: data.data.fileName,
                        originalFileName: file.name,
                        uploadedAt: new Date()
                    })
                } catch (error) {
                
                    console.log(error)
                    this.$store.commit('setError', error)
                }
                this.$store.commit('setLoading', false)
            }
        }, // End of onFileInput() method
    }, // End of Component > mounted
} // End of export default
</script>
